module.exports = __webpack_public_path__ + "images/leistungen/saubere_filme_leistungen.jpg";